import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StatutProfessionnel } from 'src/app/shared/models/statutProfessionnel';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class StatutProfessionnelService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllStatutProfessionnel(): Observable<StatutProfessionnel[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.statutProfessionnelUrl}/all`,
			'getAllStatutProfessionnel'
		);
	}

	importStatutProfessionnel(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'statutProfessionnel.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.statutProfessionnelUrl}/import`,
			`importStatutProfessionnel`,
			formData
		);
	}

	getStatutProfessionnelById(id: number): Observable<StatutProfessionnel> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.statutProfessionnelUrl}/get/${id}`,
			'getStatutProfessionnelById'
		);
	}

	updateStatutProfessionnel(statutProfessionnel: StatutProfessionnel): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.statutProfessionnelUrl}/update/${statutProfessionnel.id}`,
			'updateStatutProfessionnel',
			statutProfessionnel
		);
	}

	addStatutProfessionnel(statutProfessionnel: StatutProfessionnel): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.statutProfessionnelUrl}/add`,
			'addStatutProfessionnel',
			statutProfessionnel
		);
	}

	deleteStatutProfessionnel(statutProfessionnelId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.statutProfessionnelUrl}/delete/${statutProfessionnelId}`,
			`deleteStatutProfessionnel`
		);
	}
}
